import React, { useMemo } from 'react';
import { TableRow } from '@mui/material';
import TableCell from 'src/components/Table/TableCell';
import PropTypes from 'prop-types';
import selectFormatDate from 'src/utils/selectDateFormat';
import MoreMenu from 'src/components/MoreMenu/MoreMenu';
import GetAppIcon from '@mui/icons-material/GetApp';
import dateFormatType from 'src/utils/dateFormatType';
import getFileFromExternalLink from 'src/utils/document';
import { Link } from 'react-router-dom';

const PartialReportActions = {
  DOWNLOAD_TXT: 'DOWNLOAD_TXT',
  DOWNLOAD_EXCEL: 'DOWNLOAD_EXCEL'
};

const PartialReportRow = ({
  id,
  date,
  upToDateContractsCount,
  overdueContractsCount,
  document,
  excelDocument
}) => {
  const formattedDate = selectFormatDate(date, dateFormatType.DAY);

  const handleClickOption = action => {
    if (action === PartialReportActions.DOWNLOAD_EXCEL && excelDocument) {
      getFileFromExternalLink(
        excelDocument.documentUrl,
        `Reporte de buró parcial ${formattedDate}.xlsx`
      );
    } else {
      getFileFromExternalLink(
        document.documentUrl,
        `Reporte de buró parcial ${formattedDate}`
      );
    }
  };

  const getMoreMenuOptions = useMemo(() => {
    const options = [
      {
        name: PartialReportActions.DOWNLOAD_TXT,
        label: 'BUREAU_REPORTS.DOWNLOAD_TXT',
        icon: <GetAppIcon />
      }
    ];

    if (excelDocument) {
      options.push({
        name: PartialReportActions.DOWNLOAD_EXCEL,
        label: 'BUREAU_REPORTS.DOWNLOAD_EXCEL',
        icon: <GetAppIcon />
      });
    }

    return options;
  }, [excelDocument]);

  return (
    <TableRow hover>
      <TableCell align="center">
        <Link to={`/income/bureau-reports/detail/${id}`}>{formattedDate}</Link>
      </TableCell>
      <TableCell align="center">
        {upToDateContractsCount + overdueContractsCount}
      </TableCell>
      <TableCell align="right">
        <MoreMenu
          deleteDisabled
          editDisabled
          options={getMoreMenuOptions}
          handleClickOption={handleClickOption}
        />
      </TableCell>
    </TableRow>
  );
};

PartialReportRow.propTypes = {
  id: PropTypes.number.isRequired,
  date: PropTypes.string.isRequired,
  upToDateContractsCount: PropTypes.number.isRequired,
  overdueContractsCount: PropTypes.number.isRequired,
  document: PropTypes.shape({ documentUrl: PropTypes.string }),
  excelDocument: PropTypes.shape({ documentUrl: PropTypes.string })
};

PartialReportRow.defaultProps = {
  document: null,
  excelDocument: null
};

export default PartialReportRow;
